/**
 * Text scris de om, pus intr-un sir de HTML.
 *
 * Coloanele lui `DataTable` intorc HTML brut, deci fiecare nume de element,
 * clasa sau serial trece pe aici inainte. Perechea din portal e `e()` din
 * `helpers/general_helper.php`, si din acelasi motiv: in baza sta textul asa cum
 * l-a scris omul, iar scaparea se face la AFISARE, o singura data.
 */
export function esc(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return ''
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
